import {
  forwardRef,
  InputHTMLAttributes,
  memo,
  ReactNode,
  Ref,
  RefObject,
} from 'react';
import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';

import { Nullable } from '../../../types';

export type CheckboxProps = ChakraCheckbox.RootProps & {
  icon?: ReactNode;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  rootRef?: RefObject<Nullable<HTMLLabelElement>>;
};

const CheckboxComponent = (
  props: CheckboxProps,
  ref: Ref<HTMLInputElement>,
) => {
  const { icon, children, inputProps, rootRef, ...rest } = props;
  return (
    <ChakraCheckbox.Root ref={rootRef} {...rest}>
      <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
      <ChakraCheckbox.Control>
        {icon || <ChakraCheckbox.Indicator />}
      </ChakraCheckbox.Control>
      {children != null && (
        <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>
      )}
    </ChakraCheckbox.Root>
  );
};

export const Checkbox = memo(
  forwardRef<HTMLInputElement, CheckboxProps>(CheckboxComponent),
);
